<template>
  <el-dialog
    title="收银模式配置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >

    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              label="当前收银模式"
      >
        {{deposit_type}}
      </el-form-item>
      <el-form-item
              label="修改收银模式"
      >
        <el-radio v-model="form.deposit_type2" label="收银">收银</el-radio>
        <el-radio v-model="form.deposit_type2" label="收银+押金">收银+押金</el-radio>
        <el-radio v-model="form.deposit_type2" label="收银+结算">收银+结算</el-radio>
        <el-radio v-model="form.deposit_type2" label="收银+押金+结算">收银+押金+结算</el-radio>
      </el-form-item>
      <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'payconfigureEditForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      accuseVisible2: true,
      loading: false,
      deposit_type: '',
      dialogVisible: false,
      form: {
        deposit_type2: '收银'
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },
    handleClick () {

    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      this.deposit_type = this.agent.deposit_type
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.agent.id) {
            this.loading = true
            agentService.saveEquipment({ ...this.form, id: this.agent.id })
              .then(data => {
                this.loading = false
                this.dialogVisible = false
                this.$emit('submit')
              })
          }
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
